export const getStatuses = (assignment) => {
  const {
    status,
    headline,
    learnositySubmittedAt,
    printToggle,
    studentScoring,
    sessionStatus,
  } = assignment || {};

  const isOpen = status === 'opened';
  const isLocked = status === 'locked';
  const isLearnositySubmitted = !!learnositySubmittedAt;
  const isSubmittedSession = sessionStatus === 'submitted';
  const isAwaitingScoring = headline === 'AWAITING SCORING';
  const isReadyToScore = headline === 'SCORE';
  const isPrint = !!printToggle;
  const isStudentScoring = !!studentScoring;

  return {
    isOpen,
    isLocked,
    isLearnositySubmitted,
    isSubmittedSession,
    isAwaitingScoring,
    isReadyToScore,
    isPrint,
    isStudentScoring,
  };
};

export const getStatusActions = (assignment) => {
  const {
    isOpen,
    isLocked,
    isLearnositySubmitted,
    isSubmittedSession,
    isAwaitingScoring,
    isReadyToScore,
    isPrint,
    isStudentScoring,
  } = getStatuses(assignment);
  const {
    headline,
    showResults,
    scoringCompletedAt,
    timer = null,
    maxScore,
    submittedAt,
  } = assignment || {};

  const canOpenAssignment =
    isOpen && (headline === 'BEGIN' || headline === 'CONTINUE');
  const isBeginTimerAssignment = headline === 'BEGIN' && timer ? true : false;
  const isMCQAwaitingScoring =
    isOpen &&
    !isLearnositySubmitted &&
    isAwaitingScoring &&
    submittedAt &&
    maxScore > 0;
  const isNoActionSubmitted =
    isSubmittedSession ||
    (isOpen && !isLearnositySubmitted && isAwaitingScoring);
  const isNoActionAwaitingScoring =
    isOpen && isLearnositySubmitted && isAwaitingScoring;
  const isNoActionPaperTest = isPrint && !isStudentScoring;
  const isNoActionNoResults = !showResults && scoringCompletedAt ? true : false;
  const canSeeResults = showResults && scoringCompletedAt ? true : false;
  const hasNoActionLocked = isLocked && !isLearnositySubmitted && !isPrint;
  /**
   * Print assignment submissions don't interact with learnosity and therefore when these assignments
   * are submitted, we have no learnosity session record. The record is only created when a teacher/ student
   * starts to score it.
   * For this reason, we cannot rely on the headline since it is based on the learnosity session table.
   * As a workaround the BE shows the score action for a student for a print assignment when
   * - student scoring is enabled on the assignment and
   * - the assignment has not been scored by either the teacher and the student
   * The last rule is simulated using maxScore == 0 since an assignment without a score will always have a
   * max score of 0.
   *
   * Here is the BE rule for reference: https://github.com/academicmerit/service-fym/blob/6012e8963a79d849ea14a779622dab336069a59a/src/ft/apc/fym/assessments/api/student_assignments.py#L352
   */
  const isMaxScore = maxScore && Number.parseInt(maxScore, 10) > 0;
  const canScore =
    isReadyToScore || (isPrint && isStudentScoring && !isMaxScore);

  return {
    canOpenAssignment,
    isNoActionSubmitted,
    isNoActionAwaitingScoring,
    isNoActionPaperTest,
    isNoActionNoResults,
    isMCQAwaitingScoring,
    canSeeResults,
    hasNoActionLocked,
    canScore,
    isBeginTimerAssignment,
  };
};
